import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useTranslation } from "react-i18next";

import {
  FlexBox,
  ContainerValueView,
  ContainerTitleEdit,
} from "components/containers";
import { Circle, IcoEdit, Label, Title } from "components/generic";
import { LOGIN_EDIT } from "utils/constants";

export const LoginDetails = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("student");
  useEffect(() => {
    const getEmail = async () => {
      const { attributes } = await Auth.currentAuthenticatedUser();
      setEmail(attributes.email ?? "");
    };
    getEmail();
  }, []);
  return (
    <ContainerValueView>
      <ContainerTitleEdit>
        <Title m="0 0 4px 0" fontSize="20px">
          {t("studentProfile.login.title")}
        </Title>

        <FlexBox justify="flex-end" onClick={() => navigate(`/${i18n.language}${LOGIN_EDIT.slice(5)}`)}>
          <IcoEdit size="1.1em" />
          <Label cursor="pointer" p="0 0 0 4px">
            Edit
          </Label>
        </FlexBox>
      </ContainerTitleEdit>
      <FlexBox direction="column" align="flex-start">
        <Label p="0">{email}</Label>
        <p>
          {Array(10)
            .fill(1)
            .map((_, i) => (
              <Circle size="8px" key={i} />
            ))}
        </p>
      </FlexBox>
    </ContainerValueView>
  );
};
